import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { HttpClientCustom } from '../shared/services/http.client';
import { Configuration } from '../shared/services/configuration';
import { SharedData } from '../shared/sharedData';
import * as FileSaver from 'file-saver';
import { Headers } from '@angular/http/src/headers';
import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Options } from 'selenium-webdriver/ie';

@Component({
  selector: 'bulk-upload',
  templateUrl: 'bulkUpload.html'
})
export class BulkUploadComponent {

  public localState: any;
  public programName: string;
  public uploadDoc: any = false;
  public allData: any = [];
  public allPageData: any = [];
  public pageSize: any = 10;
  public page = 1;
  public startingPage: any = 1;
  public endingPage: any = 10;
  public collectionSize: any;
  public showGrid: any = false;
  public attachmentFile: any;
  public selectedProcess: any = 'Select';
  public fileNameToUpload: any = null;
  public fileType: any = false;
  public uploadButtonDisable: any = false;
  public comments: any = '';
  public fileExtension: any;
  public _baseUrl: any;
  public programId: any;
  public downloadUrl: any = {
    kpiUpload: 'downloadKpiUploadTemplate',
    scoreUpload: 'downloadKpiScoreUploadTemplate',
    approversUpload: 'downloadApproverUploadTemplate',
    bulkPublish: 'downloadBulkPublishTemplate',
    bulkRuleUpload: 'downloadProgramRulesUploadTemplate',
    bulkKpiDelete: 'downloadBulkKpiDeleteTemplate'
  };
  public uploadUrls: any = {
    kpiUpload: 'uploadKpiData',
    scoreUpload: 'uploadKpiScoreData',
    approversUpload: 'uploadApproverData',
    bulkPublish: 'uploadBulkPublishData',
    bulkRuleUpload: 'uploadProgramRules',
    bulkKpiDelete: 'bulkKpiDelete'
  };

  constructor(
    public route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public _location: Location,
    public _toast: ToasterComponent,
    public viewContainerRef: ViewContainerRef,
    public _http: HttpClientCustom,
    public _global: Configuration,
    public translate: TranslateService,
    public _share: SharedData) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    _toast.setViewRef(viewContainerRef);
    let programData: any = this._share.getData();
    if (!programData.id) {
      this._location.back();
    }
    this.programId = programData.id;
    this.programName = programData.name;
    this.getAll();
  }

  public goToBackPage() {
    this._location.back();
  }
  public handleChange($event) {
    this.uploadDoc = true;
  }

  public downloadTemplate(process) {
    if (process === 'kpiUpload') {
      this.downloadKpiTemplate();
    } else if(process === 'bulkKpiDelete'){
      this.downloadKpiDeleteTemplate();
    } else {
      this.downloadAllTemplate(this.downloadUrl[process]);
    }
  }

  public downloadAllTemplate(processType) {
    try {
      let url = this._baseUrl + 'v1/webAdmin/performance/' + processType + '/' + this.fileType;
      this._http.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
        let name = this.getFileNameFromHeader(result.headers);
        FileSaver.saveAs(result.body, name);
      });
    } catch (e) {
      console.log('download error caught', e);
    }
  }

  public downloadKpiTemplate() {
    try {
      let url = this._baseUrl + 'v1/webAdmin/performance/downloadKpiUploadTemplate/'
        + this.programId + '/' + this.fileType;
      this._http.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
        let name = this.getFileNameFromHeader(result.headers);
        FileSaver.saveAs(result.body, name);
      });
    } catch (e) {
      console.log('download error caught', e);
    }
  }

  public downloadKpiDeleteTemplate() {
    try {
      let url = this._baseUrl + 'v1/webAdmin/performance/downloadBulkKpiDeleteTemplate/'
        + this.programId + '/' + this.fileType;
      this._http.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
        let name = this.getFileNameFromHeader(result.headers);
        FileSaver.saveAs(result.body, name);
      });
    } catch (e) {
      console.log('download error caught', e);
    }
  }

  public getFileNameFromHeader(headers: HttpHeaders): string {
    let header = headers.get('Content-Disposition');
    if (header == null) {
      return 'test.xlxs';
    } else {
      if (!header) {
        return null;
      }
      let result: string = header.split(';')[1].trim().split('=')[1];
      return result.replace(/'/g, '');
    }
  }
  public OnPageSizeChanged(val) {
    this.pageSize = val;
    this.getAll();
  }

  public onPageChange(event: number): void {
    if (event === 1) {
      this.startingPage = 1;
      this.endingPage = 10;
    } else {
      this.startingPage = 1 + this.pageSize;
      if (this.collectionSize > this.endingPage) {
        this.endingPage = event + this.endingPage;
      } else {
        this.endingPage = this.collectionSize;
      }
    }
    this.page = event;
    this.getAll();
  }

  public onProcessChange() {
    this.fileNameToUpload = null;

  }
  public chooseFile(event) {
    if (event.target.files && event.target.files.length > 0) {
      let self = this;
      self.attachmentFile = event.target.files[0];
      self.fileNameToUpload = event.target.files[0].name;
      event.srcElement.value = null;
    }
  }

  public validate() {
    if (this.comments.trim() === '') {
      this.translate.get('commentsMandatory').subscribe((msg)=>{
        this._toast.showError(msg);
      });
      return false;
    } else {
      return true;
    }
  }

  public uploadFile(process) {
    this.uploadAllTemplate(this.uploadUrls[process]);
  }

  public uploadAllTemplate(processType) {
    if (this.validate()) {
      this.uploadButtonDisable = true;
      let formData: FormData = new FormData();
      formData.append('file', this.attachmentFile);
      formData.append('programId', this.programId);
      formData.append('comment', this.comments);
      let url = this._baseUrl + 'v1/webAdmin/performance/' + processType;
      let  options = {responseType : 'text'};
      this._http.filePost(url, formData,options).subscribe((res) => {
       if(res != null){
        this.translate.get('fileUpdatedSuccessfully').subscribe((msg)=>{
          this._toast.showSuccess(msg);
        });
        this.getAll();
        this.fileNameToUpload = null;
        this.comments = '';
        this.selectedProcess = 'Select';
        this.uploadButtonDisable = false;
       }else{
        this.translate.get('fileUploadFailed').subscribe((msg)=>{
          this._toast.showError(msg);
        });
        this.getAll();
        this.fileNameToUpload = null;
        this.comments = '';
        this.selectedProcess = 'Select';
        this.uploadButtonDisable = false;
       }
       
      }, (error) => {
        this.translate.get('fileUpdateFailed').subscribe((msg)=>{
          this._toast.showError(msg);
          this.uploadButtonDisable = false;
        });
        
      });
    }
  }

  public getAll() {
    let self = this;
    let url = self._baseUrl + 'v1/webAdmin/uploadProcess/getAllByGroup?group=PERFORMANCE'
      + '&page=' + self.page + '&pageSize=' + self.pageSize;
    self._http.get(url).subscribe((result) => {
      self.allData = result.content;
      self.allPageData = result;
      self.collectionSize = result.totalElements;
      if (self.collectionSize < self.pageSize) {
        self.endingPage = self.collectionSize;
      }
      self.showGrid = true;
    }, (error) => {
      console.log(error);
    });
  }

  public getDateFormat(date) {
    let dateCreated = new Date(date);
    return dateCreated.toString().substring(4, 15);
  }

   public getExtension(fileName){
    this.fileExtension = fileName.split('.').pop();
    return this.fileExtension.toLowerCase();
  }

  public downloadValidationFile(path) {
    let self = this;
    let url = self._baseUrl + 'v1/webAdmin/uploadProcess/downloadFile/' + path;
    this._http.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
      let name = this.getFileNameFromHeader(result.headers);
      FileSaver.saveAs(result.body, name);
    }, (error) => {
      console.log(error);
    });
  }

  public clearSelection() {
    this.showGrid = false;
  }
  public onFileTypeChange(event) {
    if (event === 'xlsx' || event === 'XLSX') {
      this.fileType = false;
    } else {
      this.fileType = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/bulkUpload/bulkUpload.ts